import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import ListConditionSetupView
  from "@/components/TriggerSetup/components/ListConditionSetupView/ListConditionSetupView.vue";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import i18n from '@/i18n/i18n'

const condition: () => EntityData = () => {
  return {
    'setupView': ListConditionSetupView,
    'structure': {
      'type': 'MessageWordStartWith',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('MessageWordStartWith') }`,
    'limited': getTagsByFieldKey('MessageWordStartWithCondition'),
  }
}

export default condition
